import { darkPalette } from "../palette";

export const MuiInputBase = {
  MuiInputBase: {
    root: {
      "&.Mui-disabled": {
        color: darkPalette.grey[600],
      },
    },
    input: {
      "&.Mui-disabled": {
        cursor: "not-allowed",
      },
    },
  },
};
